<script setup lang="ts">
import type { Props, Slots } from './types';

defineProps<Props>();
defineSlots<Slots>();
</script>

<template>
	<label class="top-caption">
		<div class="top-caption_title">
			{{ title ? title : '&nbsp;' }}
		</div>

		<slot></slot>
	</label>
</template>

<style>
.top-caption {
	display: flex;
	flex-direction: column;
	gap: var(--top-gap-1);
}

.top-caption_title {
	color: var(--color-text-3);
	font-size: 12px;
}
</style>
